<div class="data-table-caption">
    <div *ngIf="title">{{ title }}</div>
    <div class="flex-row justify">
        <div>
            <ng-content selector=".settings"> </ng-content>
            <ng-content selector=".header"> </ng-content>   
        </div>
        <div>
            <div class="flex-row end gap-small">
                <button mat-button class="button" (click)="openAddDefaultConfigs()" *ngIf="enableDefaultConfigs"  matTooltip="Add Default Configuration">
                    <mat-icon class="config-button">perm_data_setting</mat-icon>
                </button>
                <div *ngIf="(filterConfigs$|async).length">
                    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu" class="button" matTooltip="Add Filter">
                        <mat-icon svgIcon="filter"> </mat-icon>
                    </button>
                    <mat-menu class="mat-menu" #menu="matMenu" (closed)="resetFilterValues()">
                        <div mat-menu-item (click)="$event.stopPropagation()">
                            <mat-form-field class="full-width filterOptions">
                              <mat-label> Field </mat-label>
                              <mat-select [(value)]="selectedColumn">
                                <mat-option *ngFor="let filter of filterConfigs$|async" [value]="filter">
                                  {{ filter.column }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                        </div>

                        <div mat-menu-item (click)="$event.stopPropagation()">
                            <mat-form-field class="full-width filterOptions">
                              <mat-label> Filter Type </mat-label>
                              <mat-select [(value)]="selectedFilterType">
                                <mat-option *ngFor="let filterType of getFilterTypeValues(selectedColumn.type).values" [value]="filterType">
                                  {{ filterType }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                        </div>

                        <div mat-menu-item *ngIf="selectedColumn.type === 'select-string' || selectedColumn.type === 'select-number'" (click)="$event.stopPropagation()">

                            <mat-form-field class="full-width filterOptions" *ngIf="!isValueLabelPairSelectColumn(selectedColumn)">
                                <mat-label>{{selectedColumn.column}}</mat-label>
                                <mat-select [(value)]="selectedFilterValue">
                                    <mat-option *ngFor="let option of selectedColumn.options" [value]="option">
                                      {{ option }}
                                    </mat-option>
                                  </mat-select>
                            </mat-form-field>

                            <mat-form-field class="full-width filterOptions" *ngIf="isValueLabelPairSelectColumn(selectedColumn)">
                                <mat-label>{{selectedColumn.column}}</mat-label>
                                <mat-select [(value)]="selectedFilterValue">
                                    <mat-option *ngFor="let option of selectedColumn.options" [value]="option.value">
                                      {{ option.label }}
                                    </mat-option>
                                  </mat-select>
                            </mat-form-field>
                        </div>

                        <div mat-menu-item *ngIf="selectedColumn.type === 'input-string' || selectedColumn.type === 'input-number'" (click)="$event.stopPropagation()">
                            <mat-form-field class="full-width filterOptions">
                                <mat-label>{{selectedColumn.column}}</mat-label>
                                <input matInput type="text" [(ngModel)]="selectedFilterValue"/>
                            </mat-form-field>
                        </div>

                        <div mat-menu-item *ngIf="getMeasurementFilterInfo(selectedColumn).isMeasurement" (click)="$event.stopPropagation()">
                            <mat-form-field class="full-width filterOptions">
                                <mat-label>{{ selectedColumn.column }}</mat-label>
                                <measurement-input
                                    [type]="getMeasurementFilterInfo(selectedColumn).measurementType" 
                                    [unitSystem]="(selectedColumn.unitSystem$ | async)"
                                    [(ngModel)]="selectedFilterValue">
                                </measurement-input>
                            </mat-form-field>
                        </div>

                        <div mat-menu-item *ngIf="selectedColumn.type === 'date'" (click)="$event.stopPropagation()">
                            <mat-form-field class="full-width filterOptions">
                                <mat-label>{{selectedColumn.column}}</mat-label>
                                <date-time-picker [(value)]="selectedFilterValueAsDate"></date-time-picker>
                            </mat-form-field>
                        </div>

                        <div class="container flex-row end bottom">
                            <div>
                                <button mat-flat-button color="primary" [disabled]="(!selectedFilterValue && selectedColumn.column !== 'Permissions') || selectedFilterType === 'Choose filter..'" (click)="addFilter(selectedColumn,selectedFilterType,selectedFilterValue)" class="button">
                                  <span>Filter</span>
                                </button>
                            </div>
                        </div>
                        
                      </mat-menu>
                </div>                                
                <div *ngIf="addable()">
                    <button mat-button color="primary" class="button" [disabled]="selected.size === 0" (click)="_delete()">
                        <mat-icon svgIcon="trash"> </mat-icon>
                        Remove
                    </button>
                    <button mat-flat-button color="primary" (click)="add()" class="button">
                        Add
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="full-width">
        <mat-chip-grid #chipGrid aria-label="Enter filters">
            <mat-chip-row
                *ngFor="let filter of filters"
                (removed)="removeFilter(filter)"
            >
                    <!-- Date Filter Tag -->
                    <ng-container *ngIf="filter.spec === 'date'">
                        {{ filter.column }} {{filter.type}}
                        <strong class="offset-filter-value">{{ filter.value | date: 'd/M/yy HH:mm' }}</strong>
                    </ng-container>
        
                    <!-- Measurement Filter Tag -->
                    <ng-container *ngIf="getMeasurementTagInfo(filter).isMeasurement && getMeasurementTagInfo(filter).measurementType == 'particleSize'">
                        {{ filter.column }} {{ filter.type}}
                        <measurement 
                            class="small-card-content primary measurement-tag offset-filter-value" 
                            type="particleSize" 
                            [unitSystem]="particleSizeUnitSystem$ | async" 
                            [value]="getNumericValue(filter.value)">
                        </measurement>
                    </ng-container>

                    <ng-container *ngIf="getMeasurementTagInfo(filter).isMeasurement && getMeasurementTagInfo(filter).measurementType == 'largeDensity'">
                        {{ filter.column }} {{ filter.type}}
                        <measurement
                            class="small-card-content primary measurement-tag offset-filter-value" 
                            type="largeDensity" 
                            [unitSystem]="particleSizeUnitSystem$ | async" 
                            [value]="getNumericValue(filter.value)">
                        </measurement>
                    </ng-container>

                    <ng-container *ngIf="getMeasurementTagInfo(filter).isMeasurement && getMeasurementTagInfo(filter).measurementType == 'distance'">
                        {{ filter.column }} {{ filter.type}}
                        <measurement 
                            class="small-card-content primary measurement-tag offset-filter-value" 
                            type="distance" 
                            [unitSystem]="particleSizeUnitSystem$ | async" 
                            [value]="getNumericValue(filter.value)">
                        </measurement>
                    </ng-container>
        
                    <!-- Default display for other filter columns Tags -->
                    <ng-container *ngIf="filter.spec === 'select-string' || filter.spec === 'input-string' || filter.spec === 'select-number' || filter.spec === 'input-number'">
                        {{ filter.column }} {{ filter.type}}
                        <strong class="offset-filter-value">{{ filter.label || filter.value }}</strong>
                    </ng-container>
                
                <button matChipRemove [attr.aria-label]="'remove ' + filter.value">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
        </mat-chip-grid>        
    </div>
</div>
<div class="table-container">
    <table class="data full-width">
        <thead>
            <tr>
                <th>
                    <mat-checkbox [ngModel]="selected.size === (pageRecords$ | async)?.length"
                        (ngModelChange)="selectAll($event)">
                    </mat-checkbox>
                </th>
                <ng-container *ngIf="headerContent" [ngTemplateOutlet]="headerContent.templateRef"></ng-container>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="!(pageRecords$ | async)">
                <td colspan="1000">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
            </tr>
            <tr *ngFor="let record of pageRecords$ | async">
                <td>
                    <mat-checkbox [ngModel]="selected.has(record)" (ngModelChange)="$event ? selected.add(record) : selected.delete(record)"></mat-checkbox>
                </td>
                <ng-container *ngTemplateOutlet="rowContent.templateRef; context: { record }"></ng-container>
                <td>
                    <div class="flex-row end gap-small">
                        <ng-container *ngIf="actionsContent">
                            <ng-container *ngTemplateOutlet="actionsContent.templateRef;context: { record }"></ng-container>
                        </ng-container>
                        <button mat-stroked-button class="action-button" (click)="edit(record)">
                            <mat-icon svgIcon="edit" class="mat-icon-svg"></mat-icon>
                        </button>
                        <button *ngIf="deletable(record)" button mat-stroked-button class="action-button" [disabled]="!deletable(record)"
                            (click)="_delete(record)">
                            <mat-icon svgIcon="trash" class="mat-icon-svg"></mat-icon>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<mat-paginator [length]="recordCount$ | async" [pageSize]="pageSize$ | async" [pageSizeOptions]="[25, 50, 100]" (page)="onPage($event)">
</mat-paginator>